export default "__VITE_ASSET__DeRqy5eg__"